/**
 * German Dashboard Content - UI strings for German dashboard at /de/dashboard
 * This file contains all translatable strings for the dashboard interface.
 */
window.GermanDashboardContent = {
    // ==========================================
    // HEADER & NAVIGATION
    // ==========================================
    header: {
        dashboard: "Dashboard",
        responses: "Antworten",
        myForms: "Meine Formulare",
        signOut: "Abmelden",
        upgrade: "Upgrade",
        free: "Kostenlos",
        basic: "Event Pro",
        premium: "Signature",
        viewOnly: "Schreibgeschützt"
    },

    // ==========================================
    // TAB NAVIGATION
    // ==========================================
    tabs: {
        responses: "Antworten",
        analytics: "Statistiken",
        campaigns: "Gästenachrichten",
        export: "Exportieren"
    },

    // ==========================================
    // RESPONSES TAB
    // ==========================================
    responses: {
        title: "Antworten",
        totalResponses: "Gesamtantworten",
        attending: "Nehmen teil",
        notAttending: "Nehmen nicht teil",
        maybe: "Vielleicht",
        adults: "Erwachsene",
        children: "Kinder",
        searchPlaceholder: "Suchen nach Name, E-Mail oder Telefon...",
        filterAll: "Alle Antworten",
        filterYes: "Ja - Nehmen teil",
        filterNo: "Nein - Nehmen nicht teil",
        filterMaybe: "Vielleicht",
        noResponses: "Noch keine Antworten",
        noResponsesDesc: "Antworten erscheinen hier, sobald Gäste ihre Teilnahme bestätigen.",
        shareFirstDesc: "Teilen Sie den Link mit Ihren Gästen. Ihre Antworten erscheinen hier.",
        sendInvitations: "Einladungen senden",
        copyLink: "Link kopieren",
        generalLink: "Allgemeiner Link",
        personalLinks: "Persönliche Links",
        loading: "Antworten laden...",
        deleteConfirm: "Sind Sie sicher, dass Sie diese Antwort löschen möchten?",
        deleteSuccess: "Antwort erfolgreich gelöscht",
        saveSuccess: "Änderungen erfolgreich gespeichert",
        saveError: "Fehler beim Speichern der Änderungen"
    },

    // ==========================================
    // TABLE HEADERS
    // ==========================================
    table: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        attending: "Teilnahme",
        guestCount: "Gäste",
        dietary: "Ernährung",
        relationship: "Beziehung",
        message: "Nachricht",
        submittedAt: "Gesendet am",
        actions: "Aktionen",
        yes: "Ja",
        no: "Nein",
        maybe: "Vielleicht"
    },

    // ==========================================
    // ANALYTICS TAB
    // ==========================================
    analytics: {
        title: "Event-Statistiken",
        responseRate: "Antwortquote",
        totalInvited: "Gesamt eingeladen",
        totalResponded: "Gesamt geantwortet",
        pending: "Ausstehend",
        attendanceBreakdown: "Teilnahmeaufteilung",
        guestBreakdown: "Gästeaufteilung",
        responseTimeline: "Antwort-Zeitverlauf",
        dietaryPreferences: "Ernährungspräferenzen",
        relationships: "Beziehungen",
        setupTracking: "Tracking einrichten",
        setupTrackingDesc: "Geben Sie die Anzahl der gesendeten Einladungen ein, um Statistiken zur Antwortquote zu sehen.",
        invitationsSent: "Einladungen gesendet",
        manualCount: "Manuelle Zählung",
        autoDetection: "Automatische Erkennung",
        switchToAuto: "Zur automatischen Erkennung wechseln?",
        noAnalyticsYet: "Noch keine Statistiken verfügbar",
        noAnalyticsDesc: "Statistiken erscheinen, sobald Sie Antworten erhalten."
    },

    // ==========================================
    // CAMPAIGNS TAB
    // ==========================================
    campaigns: {
        title: "Gästenachrichten",
        newCampaign: "Nachrichten senden",
        sendInvitations: "Einladungen senden",
        campaignHistory: "Nachrichtenverlauf",
        noCampaigns: "Bereit, Ihre Gäste einzuladen?",
        noCampaignsDesc: "Senden Sie personalisierte Einladungen per E-Mail oder WhatsApp. Wir verfolgen, wer öffnet und antwortet.",
        createFirst: "Einladungen senden",
        contactStatus: "Kontaktstatus",
        sendReminder: "Erinnerung senden",
        scheduledReminders: "Geplante Erinnerungen",
        credits: "Guthaben",
        buyCredits: "Guthaben kaufen",
        messagesSent: "Nachrichten gesendet",
        delivered: "zugestellt",
        opened: "geöffnet",
        clicked: "angeklickt",
        responded: "geantwortet",
        pending: "ausstehend"
    },

    // ==========================================
    // CAMPAIGN WIZARD
    // ==========================================
    wizard: {
        title: "Einladungen senden",
        step1: "Kontakte",
        step2: "Überprüfen",
        step3: "Senden",
        addContacts: "Kontakte hinzufügen",
        importFromFile: "Aus Datei importieren",
        pasteContacts: "Kontakte einfügen",
        manualEntry: "Manuelle Eingabe",
        uploadCSV: "CSV hochladen",
        uploadVCard: "vCard hochladen",
        dragDropHere: "Dateien hierher ziehen oder klicken zum Durchsuchen",
        supportedFormats: "Unterstützte Formate: CSV, VCF (vCard)",
        contactsAdded: "Kontakte hinzugefügt",
        reviewContacts: "Kontakte überprüfen",
        removeSelected: "Auswahl entfernen",
        selectAll: "Alle auswählen",
        deselectAll: "Alle abwählen",
        messageTemplate: "Nachrichtenvorlage",
        personalizeMessage: "Nachricht personalisieren",
        previewMessage: "Nachrichtenvorschau",
        sendVia: "Senden via",
        email: "E-Mail",
        whatsapp: "WhatsApp",
        both: "Beide",
        schedule: "Planen",
        sendNow: "Jetzt senden",
        scheduleLater: "Für später planen",
        confirmSend: "Senden bestätigen",
        sending: "Wird gesendet...",
        sent: "Gesendet",
        failed: "Fehlgeschlagen",
        cancel: "Abbrechen",
        back: "Zurück",
        next: "Weiter",
        finish: "Fertigstellen"
    },

    // ==========================================
    // EXPORT TAB
    // ==========================================
    export: {
        title: "Daten exportieren",
        exportCSV: "Als CSV exportieren",
        exportLanguage: "Exportsprache",
        original: "Original (Nicht übersetzt)",
        selectLanguage: "Sprache wählen...",
        exportAll: "Alles exportieren",
        exportFiltered: "Gefilterte exportieren",
        downloading: "Wird heruntergeladen...",
        downloadComplete: "Download abgeschlossen",
        noDataToExport: "Keine Daten zum Exportieren"
    },

    // ==========================================
    // MODALS
    // ==========================================
    modals: {
        editResponse: "Antwort bearbeiten",
        deleteResponse: "Gast löschen",
        confirmDelete: "Sind Sie sicher, dass Sie diese Antwort löschen möchten? Dies kann nicht rückgängig gemacht werden.",
        sendReminder: "Intelligente Erinnerung senden",
        reminderDesc: "Empfänger werden basierend auf der Nachrichtenverfolgung gefiltert.",
        recipients: "Empfänger",
        customMessage: "Benutzerdefinierte Nachricht (optional)",
        customMessagePlaceholder: "Fügen Sie eine persönliche Notiz hinzu...",
        scheduledReminders: "Geplante Erinnerungen konfigurieren",
        enableReminders: "Geplante Erinnerungen aktivieren",
        reminderTiming: "Wann Erinnerungen gesendet werden sollen:",
        oneDay: "1 Tag vorher",
        threeDays: "3 Tage vorher",
        oneWeek: "1 Woche vorher",
        twoWeeks: "2 Wochen vorher",
        contactStatus: "Kontaktstatus",
        allContacts: "Alle Kontakte",
        respondedFilter: "Haben geantwortet",
        pendingFilter: "Antwort ausstehend",
        doubleResponse: "Doppelte Antwort ⚠️",
        emailStatus: "E-Mail-Status",
        whatsappStatus: "WhatsApp-Status",
        translating: "Antworten übersetzen",
        translatingTo: "Antworten übersetzen in"
    },

    // ==========================================
    // USER EVENTS
    // ==========================================
    events: {
        myEvents: "Meine Events",
        noEvents: "Keine Events gefunden",
        noEventsDesc: "Sie haben noch kein RSVP-Formular erstellt.",
        createFirst: "Erstellen Sie Ihr erstes Event",
        created: "Erstellt",
        eventId: "Event-ID",
        viewResponses: "Antworten ansehen",
        loadingEvents: "Lade Ihre Events...",
        errorLoading: "Fehler beim Laden Ihrer Events"
    },

    // ==========================================
    // AUTH
    // ==========================================
    auth: {
        signIn: "Anmelden",
        signInDesc: "Melden Sie sich an, um Ihre Formulare zu sehen",
        signInPrompt: "Melden Sie sich an für Zugriff",
        loginWithEmail: "Mit E-Mail anmelden",
        loginWithGoogle: "Weiter mit Google",
        loginWithApple: "Weiter mit Apple",
        or: "oder",
        noAccount: "Kein Konto?",
        createAccount: "Konto erstellen"
    },

    // ==========================================
    // COMMON
    // ==========================================
    common: {
        loading: "Laden...",
        save: "Speichern",
        cancel: "Abbrechen",
        close: "Schließen",
        delete: "Löschen",
        edit: "Bearbeiten",
        confirm: "Bestätigen",
        send: "Senden",
        search: "Suchen",
        filter: "Filtern",
        refresh: "Aktualisieren",
        backToEvents: "Zurück zu Meinen Events",
        backToAccess: "Zurück zu Zugriffsoptionen",
        selectEvent: "Event auswählen",
        selectEventDesc: "Bitte wählen Sie ein spezifisches Event aus dem Dropdown-Menü oben.",
        error: "Fehler",
        success: "Erfolg",
        warning: "Warnung",
        info: "Info",
        guests: "Gäste"
    },

    // ==========================================
    // UPGRADE PROMPTS
    // ==========================================
    upgrade: {
        unlockResponses: "Alle Antworten freischalten",
        freeLimit: "Sie können bis zu 25 Antworten sehen.",
        upgradeForUnlimited: "Upgrade für unbegrenzte Ansicht →",
        upgradeRequired: "Upgrade erforderlich"
    },

    // ==========================================
    // MODALS
    // ==========================================
    modals: {
        editResponse: "Antwort bearbeiten",
        deleteResponse: "Gast löschen",
        confirmDelete: "Sind Sie sicher, dass Sie diese Antwort löschen möchten?"
    },

    // ==========================================
    // ANALYTICS INSIGHTS (Dynamic JS Content)
    // ==========================================
    insights: {
        // Pattern Insights
        peakResponseDay: "Spitzentag der Antworten",
        peakResponseTime: "Spitzenzeit der Antworten",
        responseMomentum: "Antwort-Momentum",
        attendanceRate: "Teilnahmequote",
        daysUntilEvent: "Tage bis zum Event",
        eventDay: "Event-Tag",

        // Velocity labels
        pickingUp: "Nimmt zu",
        slowingDown: "Nimmt ab",
        steadyPace: "Stabiles Tempo",
        responsesComing: "Antworten kommen in letzter Zeit schneller",
        responseDecreased: "Antwortrate ist zurückgegangen",
        consistentRate: "Konstante Antwortrate",

        // Smart Insights
        excellentResponseRate: "Exzellente Antwortquote",
        lowResponseRate: "Niedrige Antwortquote",
        highGuestMultiplier: "Hoher Gästemultiplikator",
        lowerGuestImpact: "Geringerer Gäste-Einfluss",
        attendanceConcerns: "Teilnahme-Bedenken",
        strongAttendance: "Starke Teilnahme-Verpflichtung",

        // Insight descriptions
        respondedWellAbove: "der Gäste haben geantwortet - weit über dem Durchschnitt!",
        onlyResponded: "Nur haben geantwortet. Erwägen Sie Erinnerungen.",
        guestImpact: "Gäste-Einfluss - Leute bringen Begleitung mit!",
        ensureVenue: "Stellen Sie sicher, dass Veranstaltungsort und Catering eine größere Menge bewältigen können.",
        fewerPlusOnes: "Gäste-Einfluss deutet auf weniger Begleitungen hin als erwartet.",
        encourageCompanions: "Erwägen Sie, Gäste zu ermutigen, Begleitung mitzubringen.",
        respondentsAttending: "der Antwortenden werden teilnehmen.",
        investigateBarriers: "Prüfen Sie mögliche Konflikte oder Probleme mit Datum/Ort.",
        showsStrongInterest: "Teilnahmequote zeigt starkes Interesse an Ihrem Event!",

        // Activity insights
        greatMomentum: "Tolles Momentum!",
        activeResponses: "Aktive Antworten",
        recentActivity: "Kürzliche Aktivität",
        responsesThisWeek: "Antworten diese Woche mit zunehmendem Tempo - Ihre Verbreitung funktioniert",
        responsesLast7Days: "Antworten in den letzten 7 Tagen - gutes Engagement",
        responseInLast: "Antwort(en) in den letzten 7 Tagen",

        // Prediction
        expectedFinalAttendance: "Erwartete endgültige Teilnahme",
        projecting: "Prognose von",
        totalGuests: "Gästen insgesamt basierend auf aktuellen Trends",
        highConfidence: "hohe Zuversicht",
        moderateConfidence: "moderate Zuversicht",
        earlyEstimate: "frühe Schätzung",
        getMoreResponses: "Holen Sie mehr Antworten ein, um die Genauigkeit zu verbessern",

        // Event countdown
        finalCountdown: "Finaler Countdown!",
        comingSoon: "Bald",
        timeToPrepare: "Zeit zur Vorbereitung",
        daysRemaining: "Tag(e) verbleibend",
        eventIsToday: "Ihr Event ist heute!",

        // Additional insights
        highResponseVelocity: "Hohe Antwortgeschwindigkeit",
        responsesLast24h: "Antworten in den letzten 24 Stunden deuten auf starkes Engagement hin",
        optimalCommunicationDay: "Optimaler Kommunikationstag",
        showsResponses: "zeigt",
        ofResponses: "der Antworten - ideal für Follow-ups",
        scheduleRemindersOn: "Planen Sie zukünftige Erinnerungen für maximale Antwortquote",
        slowResponseCollection: "Langsame Antwortsammlung",
        averagingResponses: "Durchschnittlich",
        responsesPerDay: "Antworten pro Tag in",
        days: "Tagen",
        considerDeadline: "Erwägen Sie Dringlichkeitsnachrichten oder Anreize",
        timeForFollowUp: "Zeit für ein Follow-up",
        noResponsesIn: "Keine Antworten seit",
        reminderCouldBoost: "Tagen - eine Erinnerung könnte das Engagement steigern",

        // Engagement insights
        highDetailEngagement: "Hohes Detail-Engagement",
        providedDietary: "haben Ernährungsinformationen angegeben - sehr engagierte Gäste",
        groupEventPattern: "Gruppen-Event-Muster",
        bringingPeople: "Gäste bringen",
        peopleOnAverage: "Personen im Durchschnitt mit - planen Sie für Gruppen",
        ensureSeating: "Sichern Sie Sitzplätze und Catering für Gruppengrößen",
        lowFieldCompletion: "Niedrige Feldausfüllung",
        hasLowCompletion: "hat eine niedrige Ausfüllrate",
        haveLowCompletion: "haben eine niedrige Ausfüllrate",
        considerRequired: "Erwägen Sie, Schlüsselfelder als Pflichtfelder zu markieren",

        // Final week
        finalWeekPush: "Letzte Woche Anstrengung nötig",
        eventIn: "Event in",
        daysWithOnly: "Tagen mit nur",
        responseRateLabel: "Antwortquote",
        attendanceRateLabel: "Teilnahmequote",
        sendUrgentReminder: "Senden Sie eine letzte dringende Erinnerung",
        finalPlanningWindow: "Letztes Planungsfenster",
        daysLeft: "Tage übrig - Zeit für finale Zählung und Logistik",
        finalizeCatering: "Finalisieren Sie Catering-Mengen und senden Sie Details an bestätigte Gäste",

        // Chart Labels
        adults: "Erwachsene",
        children: "Kinder",
        guests: "Gäste",
        dietary: "Ernährungsanforderungen",
        relationship: "Beziehung",
        attending: "Nehmen teil",
        maybe: "Vielleicht",
        notAttending: "Nehmen nicht teil",
        noResponse: "Keine Antwort",

        // Activity
        someone: "Jemand",
        confirmedAttendance: "hat Teilnahme bestätigt",
        declined: "hat abgelehnt",
        fromBulk: "von Massen",
        manual: "manuell",
        fromBulkMessaging: "von Massennachrichten",
        clickToAdjust: "Klicken zum Anpassen",
        sendBulkToUnlock: "Senden Sie Nachrichten, um diese Kennzahl freizuschalten",
        guestsConfirmed: "Gäste bestätigt von",
        invitations: "Einladungen",
        day: "Tag",
        untilEvent: "bis zum Event",

        // Saturation
        responseSaturation: "Antwort-Sättigung erreicht",
        patternSuggests: "Das Muster deutet darauf hin, dass Sie die meisten verfügbaren Antworten erhalten haben",

        // Live Activity
        liveUpdates: "Live-Updates",
        live: "Live",
        reached: "Erreicht",
        responses: "Antworten!",
        latest: "Neueste",

        // Day names
        sunday: "Sonntag",
        monday: "Montag",
        tuesday: "Dienstag",
        wednesday: "Mittwoch",
        thursday: "Donnerstag",
        friday: "Freitag",
        saturday: "Samstag",

        // Time ranges
        morning: "Morgen (6-12 Uhr)",
        afternoon: "Nachmittag (12-18 Uhr)",
        evening: "Abend (18-22 Uhr)",
        night: "Nacht (22-6 Uhr)",

        // Yes/No/Maybe
        yes: "ja",
        no: "nein",

        // Smart insights empty state
        smartInsightsWillAppear: "Smarte Insights erscheinen, wenn mehr Antworten eintreffen..."
    },

    // ==========================================
    // BULK SHARING WIZARD (Full UI)
    // ==========================================
    bulkWizard: {
        // Builder-mount success screen (first send from the Share step).
        remindersOnDashboard: "Erinnerungen, Zustellstatus und Nachfassnachrichten findest du im Dashboard.",
        goToDashboard: "Dashboard öffnen",
        outcomeScheduledTitle: "Nachricht geplant",
        outcomeScheduledBody: "Ihre Nachricht wird am {date} versendet.",
        outcomeApprovalTitle: "Warten auf die Freigabe durch WhatsApp",
        outcomeApprovalBody: "WhatsApp prüft jede neue Nachricht vor dem Versand, meist innerhalb weniger Minuten. Ihre WhatsApp-Gäste erhalten sie, sobald sie freigegeben ist, und Sie müssen nichts weiter tun.",
        outcomeApprovalOthersSent: "Gäste, die sie per E-Mail oder SMS erhalten, bekommen sie jetzt.",
        outcomeHeldTitle: "Ihre erste Nachricht wird geprüft",
        outcomeHeldBody: "Das ist eine einmalige Prüfung beim ersten Versand. Wir schreiben Ihnen, sobald sie freigegeben ist. Es wurde nichts gesendet und es wurden keine Credits verbraucht.",
        outcomeRefusedTitle: "WhatsApp hat diese Nachricht nicht angenommen",
        outcomeRefusedReason: "Begründung von WhatsApp: {reason}",
        outcomeRefusedOthersNow: "Gäste, die sie per E-Mail oder SMS erhalten, bekommen sie trotzdem.",
        outcomeRefusedOthersScheduled: "Gäste, die sie per E-Mail oder SMS erhalten, bekommen sie trotzdem am {date}.",
        outcomeRefusedNoOthers: "Bisher hat keiner Ihrer Gäste sie erhalten.",
        outcomeRefusedFix: "Um Ihre WhatsApp-Gäste zu erreichen, bearbeiten Sie die Nachricht in Ihrem Dashboard und senden Sie sie erneut. WhatsApp prüft dann den neuen Text.",
        tplErr_trailingParam: "Ihre Nachricht darf nicht mit einem Personalisierungs-Tag wie {{name}} oder {{table_number}} ENDEN. WhatsApp erlaubt das nicht. Setzen Sie ein Wort oder einen Punkt hinter den Tag und senden Sie sie erneut.",
        tplErr_waLink: "WhatsApp erlaubt keinen Button, der zurück zu WhatsApp führt. Lassen Sie den Button woandershin verweisen und senden Sie die Nachricht erneut.",
        tplErr_imageFormat: "Für WhatsApp muss Ihr Einladungsbild ein JPG oder PNG sein. Laden Sie es in diesem Format erneut hoch und senden Sie die Nachricht erneut.",
        tplErr_imageProcess: "WhatsApp konnte Ihr Einladungsbild nicht verarbeiten. Versuchen Sie ein anderes (JPG oder PNG, unter 5 MB) und senden Sie die Nachricht erneut.",
        tplErr_category: "WhatsApp stuft Ihre Nachricht als eine andere Art von Nachricht ein, als wir sie eingeordnet haben. Senden Sie sie erneut, dann sollte sie durchgehen.",
        tplErr_layout: "WhatsApp konnte den Aufbau Ihrer Nachricht nicht lesen. Meist steht ein {{Tag}} allein in einer eigenen Zeile. Setzen Sie ihn in einen Satz und senden Sie die Nachricht erneut.",
        tplErr_duplicateName: "WhatsApp hat bereits eine Nachricht unter diesem Namen gespeichert. Benennen Sie die Nachricht um und senden Sie sie erneut.",
        tplErr_rateLimit: "Sie haben das Limit von WhatsApp für neue Nachrichten vorerst erreicht. Warten Sie kurz und senden Sie sie erneut. Es geht nichts verloren.",
        outcomeSubmitFailedTitle: "Wir konnten Ihre Nachricht noch nicht zur Freigabe an WhatsApp senden",
        close: "Schließen",
        outcomeSubmitFailedBody: "Wir versuchen es automatisch weiter und schreiben Ihnen, falls WhatsApp sie ablehnt. Sie müssen jetzt nichts tun.",
        outcomeVerifyTitle: "Bestätigen Sie Ihre E-Mail-Adresse, um sie zu senden",
        outcomeVerifyBody: "Ihre Nachricht ist gespeichert, aber es wurde noch nichts gesendet. Bestätigen Sie Ihre E-Mail-Adresse (im Tab „Teilen“ Ihres Formulars), dann wird sie automatisch versendet.",
        outcomeUpgradeTitle: "Vor dem Versand ist ein Upgrade nötig",
        outcomeUpgradeBody: "Diese Veranstaltung nutzt Funktionen aus ihrer Vorlage, für die ein Upgrade nötig ist. Führen Sie das Upgrade in ihrem Dashboard durch, dann wird Ihre Nachricht automatisch versendet. Es wurde noch nichts gesendet.",
        outcomePausedTitle: "Ihre Nachricht wurde noch nicht versendet",
        outcomePausedBody: "Sie ist gespeichert, aber es wurde noch nichts gesendet. Den Status sehen Sie in Ihrem Dashboard.",
        sendBlockedBlanks: "Ihre Nachricht enthält noch Platzhalter aus der Vorlage: {blanks}",
        sendDateMissing: "Wählen Sie ein Datum für Ihre geplante Nachricht.",
        sendDatePast: "Das geplante Datum und die Uhrzeit sind bereits vorbei. Wählen Sie einen Zeitpunkt in der Zukunft.",
        // Initial loading
        checkingAccess: "Zugriffsrechte werden überprüft...",
        wizardFailedToLoad: "Der Nachrichten-Assistent konnte nicht geladen werden. Bitte aktualisieren Sie die Seite.",

        // Progress steps
        step1Contacts: "1. Kontakte",
        step2Channels: "2. Kanäle",
        step2Review: "3. Personalisieren",
        step3FollowUp: "4. Nachfassen",
        step4Send: "5. Senden",

        // Navigation buttons
        previous: "Zurück",
        next: "Weiter",
        nextChannels: "Weiter: Zustellkanäle",
        nextCustomize: "Weiter: Personalisieren",
        nextFinalize: "Weiter: Abschließen und Senden",
        skip: "Überspringen",
        saveAsDraft: "Als Entwurf speichern",

        // Contacts step
        uploadContactList: "Kontaktliste hochladen",
        uploadContactsDesc: "Kontakte als CSV oder vCard hochladen",
        dragDropFile: "Datei hier ablegen",
        orClickToBrowse: "oder klicken zum Durchsuchen",
        chooseFile: "Datei auswählen",
        csvOrVcard: "CSV oder vCard (.vcf)",
        manuallyAddContacts: "Kontakte manuell hinzufügen",
        csvTemplate: "CSV-Vorlage",
        vcardTemplate: "vCard-Vorlage",

        // Phone tip
        phoneTip: "Telefonnummern müssen den Ländercode enthalten (z.B. +491701234567). Wenn Sie Excel verwenden, formatieren Sie die Spalte als 'Text', um Formatierungsprobleme zu vermeiden.",

        // Sending method
        sendVia: "Senden via",
        channelEmail: "E-Mail",
        channelEmailTooltip: "Per E-Mail senden. Wenn keine E-Mail vorhanden, wird Mobil verwendet.",
        channelMobile: "Mobil (WhatsApp/SMS)",
        channelMobileTooltip: "Per WhatsApp senden, mit SMS als Fallback. Wenn kein Telefon vorhanden, wird E-Mail verwendet.",
        channelHint: "1 Credit pro Kanal. Das System wechselt zu anderen Kanälen, wenn die Zustellung fehlschlägt.",
        deliveryMethod: "Versandart",
        smartDeliveryLabel: "Smarter Versand",
        smartDeliveryShortDesc: "WhatsApp/SMS wo verfügbar, sonst E-Mail.",
        smartDeliveryCreditNote: "1 Credit pro Kontakt.",
        customizeDelivery: "Anpassen",
        channelsStepTitle: "Zustellkanäle prüfen",
        channelsStepSubtitle: "Wählen Sie, wie Ihre Gäste diese Einladung erhalten.",
        usNumbersDeliveryNote: "🇺🇸 Hinweis zu US-Nummern: Meta unterstützt keinen WhatsApp-Massenversand an US-Nummern; diese werden daher automatisch per Standard-SMS zugestellt. Kanadische Nummern beginnen ebenfalls mit +1, sind aber nicht betroffen: Sie erhalten WhatsApp. Falls sich Ihre Gäste mit US-Nummern derzeit im Ausland befinden, empfehlen wir dringend, eine E-Mail-Adresse hinzuzufügen, um die Zustellung zu gewährleisten.",
        deliveryModalTitle: "Wie sollen wir zustellen?",
        deliveryOptionSmart: "Smarter Versand",
        deliveryOptionSmartTag: "Empfohlen",
        deliveryOptionSmartDesc: "WhatsApp für Kontakte außerhalb der USA, SMS für Kontakte in den USA, und E-Mail für Kontakte ohne Telefon. 1 Credit pro Kontakt.",
        deliveryOptionEmail: "E-Mail zuerst",
        deliveryOptionEmailDesc: "Bevorzugt den E-Mail-Versand. Nutzt automatisch Mobil, wenn keine E-Mail angegeben ist.",
        deliveryOptionMobile: "Mobil zuerst",
        deliveryOptionMobileDesc: "Bevorzugt den mobilen Versand (WhatsApp/SMS). Nutzt automatisch E-Mail, wenn keine Telefonnummer angegeben ist.",
        deliveryOptionBoth: "Beide Kanäle",
        deliveryOptionBothDesc: "An E-Mail und Mobil senden, wenn beide verfügbar sind.",
        deliveryOptionBothCost: "1 Credit pro Kontakt, auch mit beiden Kanälen.",
        deliveryDoneBtn: "Speichern",
        deliveryCancelBtn: "Abbrechen",
        usWhatsappShortNotice: "Massen-WhatsApp ist für US-Nummern nicht erlaubt (Meta-Richtlinie).",

        // SMS consent
        consentNotice: "Für Ihre Gäste können Nachrichten- und Datengebühren anfallen (Häufigkeit variiert); sie können mit STOP abbestellen, HELP für Hilfe.",
        usWhatsappNotice: "Gemäß der aktuellen Meta-Richtlinie können US-Telefonnummern keine Massen-WhatsApp-Nachrichten empfangen und werden automatisch auf SMS umgestellt. Sie können US-Nummern weiterhin einzeln über WhatsApp kontaktieren.",
        smsConsentCheckbox: "Ich bestätige, dass alle Empfänger der Zusendung von SMS-Einladungsnachrichten für meine Veranstaltung über QuikRSVP zugestimmt haben.",
        smsConsentDisclosure: "Empfänger können mit STOP abbestellen oder HELP für Hilfe antworten. Nachrichten- und Datengebühren können anfallen. Häufigkeit variiert.",
        smsConsentRequired: "Sie müssen die Zustimmung der Empfänger vor dem Versand bestätigen.",
        termsConsentRequired: "Bitte stimmen Sie vor dem Versand den Allgemeinen Geschäftsbedingungen und der Datenschutzrichtlinie zu.",
        smsConsentEmailFallbackHint: "Für {n} Ihrer Gäste ist keine E-Mail-Adresse hinterlegt, daher geht die Nachricht an das Telefon, möglicherweise als SMS.",
        smsConsentEditTitle: "SMS-Einwilligung bestätigen",
        smsConsentEditBody: "Einige Gäste dieser Nachricht haben US-amerikanische, andere +1- oder brasilianische Nummern und erhalten sie daher möglicherweise als SMS. Bestätigen Sie deren Einwilligung, um Ihre Änderungen zu speichern.",
        smsConsentEditSave: "Bestätigen und speichern",
        termsLink: "Allgemeine Geschäftsbedingungen",
        privacyLink: "Datenschutzrichtlinie",

        // Contact summary
        valid: "gültig",
        invalid: "ungültig",
        messages: "Nachrichten",
        editContacts: "Kontakte bearbeiten",
        invalidContacts: "Ungültige Kontakte:",

        // Follow-up banner
        followUpCampaign: "Follow-up-Nachricht",
        contactsAutoLoaded: "Kontakte wurden automatisch aus Ihrer vorherigen Nachricht geladen.",
        filterApplied: "Filter angewendet:",
        startFresh: "Neu beginnen",

        // File parsing
        dragDropCsv: "CSV-Datei hier ablegen oder klicken zum Durchsuchen",
        dragDropVcard: "vCard-Datei hier ablegen oder klicken zum Durchsuchen",
        csvColumns: "Spalten: Gastname(n), Gruppenname, Telefon, E-Mail (optional: Max. Gäste, Tags)",
        downloadCsvTemplate: "CSV-Vorlage herunterladen",
        downloadVcardTemplate: "vCard-Vorlage herunterladen",
        vcardFromSources: "Standard .vcf-Datei aus Quellen wie Google Contacts oder Outlook.",

        // Send step
        readyToSend: "Bereit zum Senden!",
        reviewAndSend: "Überprüfen Sie Ihre Nachrichtendetails und senden Sie Ihre Einladungen.",
        campaignSummary: "Nachrichtenübersicht",
        totalMessages: "Nachrichten gesamt",
        emailLabel: "E-Mail",
        mobileLabel: "Mobil",

        // Reminders
        remindersEnabled: "Erinnerungen aktiviert:",

        // Credits
        messageCredits: "Nachrichten-Guthaben",
        yourBalance: "Ihr Guthaben",
        creditsNeeded: "Benötigte Credits",
        readyToSendCredits: "Bereit zum Senden! Sie haben genügend Credits für diese Nachricht.",
        needMoreCredits: "Sie benötigen mehr Credits.",
        purchasePackage: "Kaufen Sie ein Paket, um fortzufahren.",

        // Send timing
        sendTiming: "Sendezeitpunkt",
        sendImmediately: "Sofort senden",
        messagesQueuedNow: "Nachrichten werden sofort in die Warteschlange gestellt",
        scheduleForLater: "Für später planen",
        chooseDateTime: "Wählen Sie ein bestimmtes Datum und eine Uhrzeit",
        date: "Datum",
        time: "Uhrzeit",
        schedulingNote: "Die Zustellzeit ist ungefähr und nicht garantiert. Nachrichten werden zur geplanten Zeit zur Verarbeitung eingereiht.",

        // Buttons
        sendCampaign: "Gäste benachrichtigen",
        upgradeAndBuyCredits: "Upgrade und Credits kaufen",
        buyCredits: "Credits kaufen",

        // Credits info
        creditsInfo: "Credits werden pro Gast gezählt, nicht pro Nachricht • Credits verfallen nie • Funktionieren mit allen Formularen",
        // Send step: guests per channel and the one cost line (_deliveryPlanHtml).
        deliveryPlanTitle: "So erhalten Ihre Gäste die Nachricht",
        deliveryWhatsapp: "WhatsApp",
        deliverySms: "SMS",
        deliveryEmail: "E-Mail",
        deliveryGuestsOne: "1 Gast",
        deliveryGuestsMany: "{n} Gäste",
        deliveryFullDesc: "Ihre vollständige Nachricht, mit Bild und Schaltflächen, falls Sie welche hinzugefügt haben",
        deliverySmsDesc: "Nur Text: kein Bild, keine Schaltflächen. Ihre Links werden als Webadressen gesendet.",
        deliverySmsDescNoLink: "Nur Text: kein Bild, keine Schaltflächen, keine Links.",
        deliverySmsWhy: "US-Nummern erhalten eine SMS, weil WhatsApp Einladungen wie diese nicht an US-Nummern zustellt.",
        deliverySmsPreview: "Die SMS ansehen, die sie erhalten",
        deliverySmsCantSend: "Diese Gäste erhalten keine SMS: Eine SMS kann nur lateinische Buchstaben enthalten, und diese Nachricht hat keine. Fügen Sie im Schritt „Personalisieren“ eine englische Fassung Ihrer Nachricht hinzu, um sie zu erreichen.",
        deliverySmsEmailOnlyOne: "1 davon hat eine E-Mail-Adresse und erhält nur die E-Mail.",
        deliverySmsEmailOnlyMany: "{n} davon haben eine E-Mail-Adresse und erhalten nur die E-Mail.",
        deliverySmsNothingOne: "1 Gast erhält nichts.",
        deliverySmsNothingMany: "{n} Gäste erhalten nichts.",
        costLabel: "Kosten",
        costCreditsOne: "1 Credit",
        costCreditsMany: "{n} Credits",
        costPerGuest: "1 Credit pro Gast",
        costPerGuestTicketed: "1 Credit pro Gast, der per Telefon erreicht wird; E-Mails sind bei Ticket-Veranstaltungen kostenlos",
        balanceAfterSending: "Guthaben nach dem Senden: {n}",
        costUnsentNote: "Credits, die für Gäste reserviert sind, die nichts erhalten, bekommen Sie nach dem Senden zurück.",
        remindersCostNote: "Jede Erinnerung kostet 1 Credit pro erreichtem Gast, sobald sie gesendet wird.",
        remindersCostNoteTicketed: "Jede Erinnerung kostet 1 Credit pro Gast, der per Telefon erreicht wird, sobald sie gesendet wird. E-Mails sind kostenlos.",
        notEnoughCreditsToSend: "Nicht genügend Credits: Sie haben {balance}, diese Nachricht braucht {needed}. Kaufen Sie weitere Credits und senden Sie dann erneut.",

        // Contact editor modal
        contactEditor: "Kontakt-Editor",
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        actions: "Aktionen",
        addNewContact: "Neuen Kontakt hinzufügen",
        saveContacts: "Kontakte speichern",
        cancel: "Abbrechen",

        // Validation
        contactsCleared: "Kontakte gelöscht. Sie können jetzt eine neue Liste hochladen.",

        // Review step labels
        composeYourMessage: "Verfassen Sie Ihre Nachricht",
        composeSubtitle: "Personalisieren Sie Ihre Einladung und wählen Sie, wie die Gäste sie erhalten.",
        messageAndTranslations: "Nachricht & Übersetzungen",
        customEmailSettings: "E-Mail-Einstellungen",
        buttonsLinks: "Buttons & Links",
        linksButtonsLabel: "Links / Buttons",
        buttonsLinksHint: "Wählen Sie bis zu 2 Buttons für Ihre Nachricht.",
        campaignButtonsMax: "Pro Nachricht sind bis zu 2 Buttons möglich",
        buttonCaptionAlsoIn: "Wird auch auf {n} gesendet",
        buttonCaptionAsTyped: "Ihr Wortlaut — wird genau so gesendet",
        buttonCaptionPairTip: "Beide Sprachen stehen zusammen auf dem Button. Passt das Paar nicht in die 25 Zeichen von WhatsApp, bleibt eine Sprache übrig — die Vorschau zeigt den genauen Wortlaut.",
        buttonLabelOptional: "Button-Beschriftung (optional)",
        buttonAppearsOn: "Die Buttons erscheinen in WhatsApp und E-Mail.",
        rsvpTargetLabel: "Wohin soll der RSVP-Link führen?",
        rsvpTargetForm: "QuikRSVP-Formular",
        rsvpTargetWebsite: "Meine Hochzeitswebsite",
        campaignName: "Nachrichtenname",
        campaignNamePlaceholder: "Benenne deine Nachricht…",
            campaignNameDefaultDescriptor: "Einladungen",
        campaignNameHelp: "Geben Sie dieser Nachricht einen Namen für die spätere Identifizierung",
        campaignNameDuplicate: "Eine Nachricht mit diesem Namen existiert bereits. Wählen Sie einen eindeutigen Namen (z. B. « - Gruppe B » anhängen) oder fügen Sie Kontakte zu Ihrer vorhandenen Nachricht hinzu.",
        campaignNameDupShort: "Eine Nachricht mit diesem Namen existiert bereits.",
        campaignNameDupViewExisting: "Vorhandene Nachricht ansehen",
        emailSubjectLine: "E-Mail-Betreff",
        emailSenderName: "Absendername",
        emailSenderNameHelp: "Anzeigename für Gäste",
        replyToLabel: "Antworten gehen an",
        replyToDefaultSuffix: "Standard",
        replyToAddOption: "Andere Adresse verwenden…",
        replyToNewPlaceholder: "name@beispiel.de",
        replyToSendVerify: "Bestätigung senden",
        replyToSending: "Wird gesendet…",
        replyToSent: "Bestätigung gesendet. Öffnen Sie das Postfach, klicken Sie auf den Link und wählen Sie die Adresse dann hier aus.",
        replyToRecheck: "Ich habe bestätigt",
        replyToAlreadyVerified: "Diese Adresse ist bereits bestätigt — wählen Sie sie in der Liste aus.",
        replyToInvalid: "Geben Sie eine gültige E-Mail-Adresse ein.",
        replyToError: "Bestätigung konnte nicht gesendet werden. Bitte erneut versuchen.",
        replyToWhyVerify: "Wir bestätigen die Adresse vorab, damit Einladungen Antworten nicht an ein Postfach leiten können, das dem Absender nicht gehört.",
        emailThemeColor: "E-Mail-Farbe",
        emailLogo: "E-Mail-Logo",
        emailLogoUpload: "Hochladen",
        emailLogoHide: "Ausblenden",
        emailLogoShow: "Anzeigen",
        emailLogoReset: "QuikRSVP-Logo verwenden",
        emailLogoPaidOnly: "Bezahlte Tarife",
        emailLogoUpgradeMsg: "Ein eigenes E-Mail-Logo ist in den bezahlten Tarifen verfügbar — führen Sie ein Upgrade durch, um es anzupassen.",
        messageHeader: "Einladungsüberschrift",
        messageHeaderHelp: "Fetter Titel oben in Ihrer E-Mail & WhatsApp-Nachricht. Löschen, um auszublenden.",
        invitationTagline: "Einladungsuntertitel",
        invitationTaglineHelp: "Kleinerer Text unter der Überschrift (z. B. \"Sie sind eingeladen\"). Löschen, um auszublenden. (nur E-Mail)",
        headerAndSubject: "Titel, Untertitel & Betreff",
        leaveBlankToHide: "Leer lassen, um auszublenden",
        yourMessage: "Ihre Nachricht",
        writeMessagePlaceholder: "Schreiben Sie hier Ihre Einladungsnachricht...",
        characters: "Zeichen",
        translateTo: "Übersetzen in:",
        translate: "Übersetzen",
        translationWillAppear: "Die Übersetzung erscheint hier...",
        // Message & Translations block (task #453)
        translateHint: "Diese Einladung auch in einer anderen Sprache senden",
        translationsReady: "Übersetzungen bereit",
        messageLanguages: "Sprachen der Nachricht",
        yourMessageBadge: "Ihre Nachricht",
        hide: "Ausblenden",
        view: "Anzeigen",
        addAnotherLanguage: "Weitere Sprache hinzufügen",
        chooseLanguage: "Auswählen…",
        willSendAsWritten: "Gäste erhalten {a} — die Nachricht genau wie geschrieben",
        willSendTranslationOnly: "Gäste erhalten nur {a} — Ihr Original wird nicht gesendet",
        willSendBoth: "Gäste erhalten {a} und {b} zusammen in einer Nachricht",
        oneTranslationOnly: "Eine Nachricht enthält Ihr Original plus eine Übersetzung. Entfernen Sie zuerst das Häkchen bei {lang}.",
        pickAtLeastOneLanguage: "Wählen Sie mindestens eine Sprache zum Senden.",
        addLanguageToTranslate: "Wählen Sie eine Sprache zum Übersetzen.",
        emptyLanguageBlocked: "Bitte Text für {langs} ergänzen oder die Sprache abwählen.",
        emptyLanguagesBlocked: "Bitte Text für diese Sprachen ergänzen oder sie abwählen: {langs}.",
        smsNotSendable: "per SMS nicht sendbar",
        smsSourceOnly: "Die SMS sendet nur Ihr Original",
        smsSendsTranslation: "Die SMS sendet stattdessen Ihre Übersetzung",
        waCombinedOver: "Beide Sprachen teilen sich eine WhatsApp-Nachricht — {n} von 1.024 Zeichen. Kürzen Sie eine davon.",
        bothWillBeSent: "Original und Übersetzung werden gesendet",
        onlyTranslationWillBeSent: "Nur die Übersetzung wird gesendet",
        sendAsWrittenDesc: "Nachricht ist bereits in der Sprache der Gäste",
        sendTranslatedOnly: "Nur übersetzte Version senden",
        bilingual: "Zweisprachig",
        sendBilingual: "Beide (Original & Übersetzung) in einer Nachricht senden",
        multiLanguageHint: "Gäste in verschiedenen Sprachen separat kontaktieren? Erstellen Sie für jede Sprache eine eigene Nachricht.",
        preview: "Vorschau",
        addImage: "Bild hinzufügen",
        changeImage: "Bild ändern",
        convertingImage: "iPhone-Foto wird konvertiert…",
        processingImage: "Bild wird verarbeitet…",
        uploadingImage: "Wird hochgeladen…",
        invitationImage: "Einladungsbild",
        invitationImageDesc: "Optional — wird oben in Ihrer E-Mail und WhatsApp-Nachricht angezeigt.",
        invitationSplashLabel: "Beim Antippen im Vollbild öffnen",
        invitationSplashDesc: "Gäste, die in WhatsApp auf Ihre Einladung tippen, sehen sie in voller Größe und danach Ihr Zusageformular.",
        beforeYouSend: "Vor dem Senden",
        goodToKnow: "Hinweise zu Guthaben & Zustellung",
        optionalLabel: "optional",
        csvFormattingTips: "CSV-Formatierungstipps",
        downloadTemplate: "Vorlage herunterladen",
        previewShowsExactly: "Die Vorschau zeigt genau, was die Gäste erhalten.",

        // What happens next
        whatHappensNext: "Was passiert als Nächstes?",

        // Success states
        campaignCreated: "Nachricht erstellt!",
        messagesQueued: "Nachrichten in Warteschlange",
        scheduledFor: "Geplant für",
        tip: "Tipp",

        // Follow-up reminders step
        followUpRemindersTitle: "Nachfass-Erinnerungen",
        followUpRemindersDesc: "Planen Sie automatische Erinnerungen für Ihre Gäste",
        saveAndResubmitWhatsApp: "Speichern und erneut an WhatsApp senden",
        saveAndResend: "Speichern und erneut senden",
        saveAndResubmitHint: "Sendet Ihre bearbeitete Nachricht zur Genehmigung zurück an WhatsApp. Sie geht anschließend an die Gäste, die sie nie erhalten haben.",
        saveAndResendHint: "Speichert Ihre bearbeitete Nachricht und sendet sie an die Gäste, die sie nie erhalten haben.",
        // Edit & Resend feedback: the save is instant, the WhatsApp
        // re-submission is not, so they are reported separately (task #592).
        editSavedChanges: "Änderungen gespeichert.",
        editSavedResubmitting: "Änderungen gespeichert. Ihre Nachricht wird zur Genehmigung an WhatsApp gesendet…",
        translationStale: "Ihre Nachricht wurde nach dieser Übersetzung geändert. Bitte aktualisieren Sie die Übersetzung.",
        translateAgain: "Erneut übersetzen",
        translationStaleBlocked: "Sie haben Ihre Nachricht nach der Übersetzung geändert. Aktualisieren Sie vor dem Senden die Übersetzung ({lang}): Tippen Sie auf „Erneut übersetzen“ oder bearbeiten Sie sie selbst.",
        translationStaleWarn: "Sie haben Ihre Nachricht nach der Übersetzung geändert. Prüfen Sie, ob die Übersetzung ({lang}) noch passt.",
        editSavedRescheduled: "Änderungen gespeichert. Ihre Nachricht wird am {date} gesendet.",
        editTimingUseSend: "Änderungen gespeichert. Ihre Nachricht ist weiterhin für {date} geplant. Um sie jetzt zu senden, tippen Sie auf „Senden“.",
        editSavedNotSent: "Änderungen gespeichert. Es wurde noch nichts gesendet. Um die Nachricht zu senden, öffnen Sie „Bearbeiten & erneut senden“ und tippen Sie auf „Senden“.",
        editSavedRescheduledPaused: "Änderungen gespeichert. Der neue Zeitpunkt ist {date}. Die Nachricht bleibt pausiert, bis Sie sie fortsetzen.",
        editTimingAfterReminder: "Eine Erinnerung zu dieser Nachricht ist für {date} geplant. Wählen Sie einen früheren Zeitpunkt oder ändern Sie zuerst die Erinnerung.",
        editTimingPast: "Dieser Zeitpunkt liegt bereits in der Vergangenheit. Bitte wählen Sie einen Zeitpunkt in der Zukunft.",
        editTimingPickDate: "Wählen Sie Datum und Uhrzeit für den geplanten Versand.",
        editResubmitAccepted: "Ihre bearbeitete Nachricht liegt WhatsApp zur Genehmigung vor. Sie geht raus, sobald sie genehmigt ist.",
        editResubmitRefused: "WhatsApp hat die Nachricht nicht akzeptiert",
        sendTestSavedAsDraft: "Ihre Nachricht wurde als Entwurf gespeichert, damit wir diesen Test senden konnten — Sie finden sie in Ihrer Nachrichtenliste.",
        editBlockedSending: "Ihre Änderungen wurden nicht gespeichert: Der Versand dieser Nachricht hat begonnen. Fügen Sie neue Gäste danach mit „Kontakte hinzufügen“ auf ihrer Karte hinzu.",
        editBlockedStale: "Ihre Änderungen wurden nicht gespeichert: Diese Nachricht wurde geändert, während Sie sie bearbeitet haben (zum Beispiel wurden Gäste hinzugefügt oder sie wurde gesendet). Schließen Sie dieses Fenster und öffnen Sie sie erneut, um die aktuelle Version zu bearbeiten.",
        nextFollowUp: "Weiter: Nachfassen",
        addAnotherReminder: "Erinnerung hinzufügen",
        removeReminder: "Entfernen",
        reminderNumber: "Erinnerung",
        whenToSend: "Wann senden",
        sendTo: "An wen senden",
        reminderMessage: "Nachricht",
        reminderButtonsLabel: "Schaltflächen",
        reminderButtonRsvp: "Zusage-Link",
        reminderRsvpAutoIncluded: "(Link automatisch enthalten)",
        reminderButtonRegistry: "Geschenkeliste",
        reminderButtonDirections: "Wegbeschreibung",
        reminderButtonWebsite: "Hochzeitswebsite",
        reminderButtonsHint: "Schaltflächen sind optional — fügen Sie bis zu 2 hinzu oder lassen Sie alle leer für eine reine Text-Erinnerung.",
        reminderButtonLabelLangHint: "Leer gelassen erscheint jede Schaltfläche in beiden Sprachen, wie gezeigt. Eine eingegebene Beschriftung wird genau so gesendet — schreiben Sie beide Sprachen, wenn Sie beide möchten.",
        reminderEditButton: "Bearbeiten",
        reminderEditTitle: "Erinnerung bearbeiten",
        reminderNewTitle: "Neue Erinnerung",
        reminderLinkedNote: "Wird als verknüpfte Erinnerung unter \"{name}\" gesendet – keine neue Nachricht.",
        reminderRecipientsFinalized: "Die Empfänger werden beim Versand der Erinnerung festgelegt.",
        reminderFixedRecipientsNote: "Diese Erinnerung geht an die {count} von Ihnen ausgewählten Empfänger.",
        reminderAudienceScopeNote: "Diese Nachfass-Nachricht wird <strong>nur</strong> an die Empfänger dieser bestimmten Nachricht gesendet – nicht an alle Gäste Ihrer Veranstaltung.",
        reminderSendNowHint: "Standard ist jetzt – wird in Kürze gesendet (sobald WhatsApp die Nachricht genehmigt). Wählen Sie ein späteres Datum/eine spätere Uhrzeit, um sie zu planen.",
        reminderCancel: "Abbrechen",
        reminderSaveChanges: "Änderungen speichern",
        reminderCreateBtn: "Erinnerung erstellen",
        reminderReviewContinue: "Weiter",
        reminderReviewPreviewNote: "Wen Sie hier entfernen, der wird nur bei dieser Erinnerung ausgelassen; Ihre anderen Erinnerungen bleiben unverändert. Der Rest der Liste wird beim Versand festgelegt — Gäste, die vorher antworten, werden zum Beispiel automatisch übersprungen.",
        removeButton: "Entfernen",
        linkChipUrlLabel: "Link",
        linkChipLabelLabel: "Schaltflächentext",
        linkChipSave: "Hinzufügen",
        linkChipUrlRequired: "Füge einen Link hinzu oder brich ab.",
        remindAllTitle: "Erinnerung senden",
        remindAllSubtitle: "{n} Empfänger",
        remindAllPreConfigure: "Derzeit passen keine Gäste. Diese Erinnerung geht beim Senden automatisch an alle, die dann passen.",
        remindAllSendingTo: "Wird an <strong>{n}</strong> ausgewählte Gäste gesendet.",
        remindAllAddedOptedOut: "Für {n} der hinzugefügten Gäste sind Erinnerungen für dieses Event ausgeschaltet, daher erhalten sie diese nicht.",
        remindAllContinue: "Weiter zum Senden",
        remindAllNextStepHint: "Im nächsten Schritt wählst du die Versandart und bestätigst die Kosten.",
        reminderUpdatedToast: "Erinnerung aktualisiert",
        reminderResubmittedToast: "Erinnerung aktualisiert und erneut zur Freigabe an WhatsApp gesendet.",
        reminderCreatedToast: "Erinnerung erstellt – sie wird zur geplanten Zeit gesendet.",
        reminderSendingNowToast: "Ihre Erinnerung ist unterwegs – sie wird jetzt gesendet.",
        reminderUpdateFailed: "Erinnerung konnte nicht aktualisiert werden: ",
        reminderCreateFailed: "Erinnerung konnte nicht erstellt werden: ",
        reminderAlertPickDateTime: "Bitte wählen Sie Datum und Uhrzeit für den Versand.",
        reminderAlertTrailingTag: "Ihre Nachricht darf nicht mit einem Personalisierungs-Tag wie {{table_number}} enden — WhatsApp erlaubt das nicht. Fügen Sie danach ein paar Worte hinzu (z. B. \"Bis dann!\").",
        reminderAlertValidDateTime: "Bitte geben Sie ein gültiges Datum und eine gültige Uhrzeit ein.",
        reminderAlertRegistryUrl: "Fügen Sie eine URL für den Geschenkelisten-Link hinzu oder deaktivieren Sie ihn.",
        reminderAlertDirectionsUrl: "Fügen Sie eine URL für den Wegbeschreibungs-Link hinzu oder deaktivieren Sie ihn.",
        reminderAlertWebsiteUrl: "Fügen Sie eine URL für den Link zur Hochzeitswebsite hinzu oder deaktivieren Sie ihn.",
        reminderAlertLivestreamUrl: "Fügen Sie einen Link für den Livestream hinzu oder entfernen Sie das Häkchen.",
        reminderSendNowChoice: "Jetzt senden",
        reminderScheduleChoice: "Für später planen",
        reminderGoesOutShortly: "Ihre Erinnerung geht in Kürze raus (sobald WhatsApp die Nachricht freigibt).",
        reminderHourOnlyHint: "Erinnerungen werden zur vollen Stunde gesendet (Minuten werden nicht verwendet).",
        reminderIncludeImage: "Einladungsfoto einfügen",
        reminderImageHeading: "Bild",
        reminderTranslateLabel: "Auch eine {lang}-Übersetzung senden",
        reminderTranslateHint: "Standardmäßig aus – Ihre Erinnerung wird genau wie geschrieben gesendet. Aktivieren, um sie automatisch zu übersetzen und anzuhängen.",
        useDifferentLink: "Anderen Link verwenden…",
        reminderIncludeThisImage: "Dieses Bild einfügen",
        reminderUseDifferentImage: "Anderes Bild verwenden",
        reminderCustomImageNote: "Diese Erinnerung verwendet ein anderes Bild als die Einladung.",
        reminderButtonsMax: "Sie können bis zu 2 Schaltflächen pro Erinnerung hinzufügen.",
        reminderButtonUrlPlaceholder: "Link einfügen (https://...)",
        invalidButtonUrlWarning: "Das sieht nicht wie ein gültiger Weblink aus. Falls es eine Adresse ist, fügen Sie den Link aus Google Maps ein — ungültige Links werden in WhatsApp-Nachrichten weggelassen.",
        reminderDirectionsUrlPlaceholder: "Google Maps- oder Waze-Link",
        reminderButtonUrlMissing: "Fügen Sie einen Link für die ausgewählte Schaltfläche hinzu oder wählen Sie sie ab.",
        resetToDefault: "Standard wiederherstellen",
        guestsWhoHaventRSVPd: "Gäste, die nicht geantwortet haben",
        attendingGuests: "Teilnehmende Gäste",
        allGuests: "Alle Gäste",
        guestsAnsweredMaybe: "Gäste, die mit „Vielleicht“ geantwortet haben",
        guestsDeclined: "Gäste, die abgesagt haben",
        twoWeeksBefore: "2 Wochen vor der Veranstaltung",
        oneWeekBefore: "1 Woche vor der Veranstaltung",
        threeDaysBefore: "3 Tage vor der Veranstaltung",
        oneDayBefore: "1 Tag vor der Veranstaltung",
        dayOfEvent: "Am Tag der Veranstaltung",
        oneDayAfter: "Am Tag nach der Veranstaltung",
        threeDaysAfter: "3 Tage nach der Veranstaltung",
        reminderButtonAlbum: "Gäste-Fotoalbum",
        reminderButtonLivestream: "Livestream",
        reminderLivestreamUrlPlaceholder: "YouTube-, Zoom- oder Facebook-Live-Link",
        reminderAlbumOff: "Schalte das Album im Tab „Gästefotos“ ein, um den Link zu erhalten.",
        customDate: "Eigenes Datum",
        pickReminderDate: "Datum auswählen",
        reminderTime: "Uhrzeit",
        reminderTimeHint: "Wird zu dieser Uhrzeit gesendet – in deiner lokalen Zeitzone.",
        guestNightWarning: "Hinweis: Viele deiner Gäste bekommen das nachts (gegen {time} ihrer Ortszeit). Es wird trotzdem zur gewählten Zeit gesendet, aber tagsüber antworten Gäste meist schneller.",
        reminderTimePast: "Wähle ein Datum und eine Uhrzeit in der Zukunft für deine eigene Erinnerung",
        reminderDateInvalid: "Das Erinnerungsdatum muss am oder vor dem Veranstaltungsdatum liegen",
        reminderDateMissing: "Bitte wähle ein Datum für deine eigene Erinnerung",
        reminderNoEventDate: "Deine Veranstaltung hat noch kein Datum, daher kann eine Erinnerung nur an einem Datum gesendet werden, das du auswählst. Wähle „Eigenes Datum“ oder füge das Veranstaltungsdatum im Editor hinzu, um Erinnerungen danach zu planen.",
        reminderAfterRsvpDeadline: "Die Rückmeldefrist endet, bevor diese Erinnerung fällig ist, daher wird sie nicht gesendet. Verschiebe die Rückmeldefrist im Editor, wähle einen früheren Zeitpunkt oder entferne den Zusage-Link.",
        defaultReminderMessage: "Hallo! Nur eine freundliche Erinnerung — wir würden uns freuen, von Ihnen zu hören! Bitte bestätigen Sie Ihre Teilnahme, wenn Sie können.",
        defaultAttendingMessage: "Wir freuen uns darauf, Sie zu sehen! Hier eine kurze Erinnerung zu den Veranstaltungsdetails.",
        defaultMaybeMessage: "Hallo! Sie hatten uns gesagt, dass Sie vielleicht kommen — haben Sie sich schon entschieden? Über eine endgültige Zu- oder Absage würden wir uns freuen, damit wir planen können. Bitte aktualisieren Sie Ihre Antwort, wenn Sie können.",
        creditsChargedNote: "Credits werden berechnet, wenn jede Erinnerung tatsächlich gesendet wird. Stellen Sie sicher, dass Sie zu diesem Zeitpunkt genügend Credits haben.",
        skipFollowUpNote: "Sie können diesen Schritt überspringen und später Nachfass-Nachrichten senden, indem Sie eine neue Nachricht über Ihr Dashboard erstellen.",
        remindersConfigured: "Erinnerung(en) geplant",

        // Toast messages - Payment
        paymentSuccessClickMessage: "Zahlung erfolgreich! Klicken Sie auf 'Gäste benachrichtigen', um fortzufahren.",
        paymentSuccessSendReady: "Zahlung erfolgreich! Sie können jetzt Ihre Nachricht senden.",
        paymentSuccessClickContinue: "Zahlung erfolgreich! Bitte klicken Sie auf 'Gäste benachrichtigen', um fortzufahren.",
        paymentSuccessGeneric: "Zahlung erfolgreich!",
        paymentProcessingWait: "Bitte warten Sie, während Ihre Anfrage bearbeitet wird...",
        paymentSystemUnavailable: "Zahlungssystem nicht verfügbar. Bitte aktualisieren und erneut versuchen.",
        paymentCompletedReady: "Zahlung abgeschlossen! Ihre Nachricht ist bereit zum Senden.",
        paymentSuccessEmoji: "🎉 Zahlung erfolgreich! Sie können jetzt Ihre Nachricht senden.",
        cannotSaveDraftNoEvent: "Entwurf kann nicht gespeichert werden: kein Event ausgewählt",
        pleaseLoginToSaveDrafts: "Bitte melden Sie sich an, um Entwürfe zu speichern",
        failedToSaveDraft: "Entwurf konnte nicht gespeichert werden. Bitte erneut versuchen.",
        campaignSentSuccess: "🎉 Nachricht gesendet! {count} Credits verwendet.",
        insufficientCredits: "Nicht genügend Credits. Bitte kaufen Sie mehr Credits für Ihre Nachricht.",
        errorProcessingCampaign: "Fehler bei der Verarbeitung. Bitte erneut versuchen.",
        campaignSubmitted: "Nachricht gesendet! Nachrichten werden automatisch zugestellt.",
        campaignScheduledFor: "Nachricht geplant! Nachrichten werden am {date} gesendet.",
        failedToSchedule: "Planung fehlgeschlagen. Bitte kontaktieren Sie den Support.",
        verifyEmailBeforeSending: "Bestätigen Sie vor dem Senden Ihre E-Mail-Adresse — geben Sie den Code im Teilen-Tab des Formular-Editors ein und senden Sie dann. Ihr Link funktioniert für Gäste bereits. Es wurde nichts gesendet oder berechnet.",
        translationComplete: "Übersetzung abgeschlossen!",
        translationFailed: "Übersetzung fehlgeschlagen. Bitte erneut versuchen.",
        translationFailedManual: "Übersetzung fehlgeschlagen. Bitte geben Sie die Übersetzung manuell ein.",
        messageTranslatedTo: "Nachricht übersetzt nach {language}!",
        translationFailedRetry: "Übersetzung fehlgeschlagen. Bitte erneut versuchen oder die Nachricht manuell eingeben.",
        pleaseWriteMessageFirst: "Bitte schreiben Sie zuerst eine Nachricht",
        loadFromContacts: "Meine Kontakte",
        noSavedContacts: "Noch keine gespeicherten Kontakte. Kontakte, die Sie in einer Kampagne anschreiben, werden automatisch in Ihrem Adressbuch gespeichert.",
        addressBook: "Adressbuch",
        addContact: "Kontakt hinzufügen",
        deleteContactConfirm: "Diesen Kontakt aus Ihrem Adressbuch löschen?",
        edit: "Bearbeiten",
        delete: "Löschen",
        save: "Speichern",
        contactNeedsInfo: "Ein Kontakt braucht einen Namen und eine E-Mail oder Telefonnummer.",
        importFromPhone: "Vom Telefon importieren",
        importFromPhoneCancelled: "Keine Kontakte ausgewählt.",
        importFromPhoneFailed: "Import der Kontakte fehlgeschlagen: ",
        importFromGoogle: "Aus Google Kontakten importieren",
        noGoogleContactsFound: "Keine Kontakte in Ihrem Google-Konto gefunden.",
        googleContactsFailed: "Google Kontakte konnten nicht geladen werden: ",
        importFromResponses: "Meine Gästeliste verwenden",
        importFromResponsesTitle: "Aus Ihrer Gästeliste importieren",
        importFromResponsesSubtitle: "Alle auf der Gästeliste dieser Veranstaltung: Gäste, die geantwortet haben, und Gäste, die Sie hinzugefügt haben und die noch nicht geantwortet haben. Nur wer eine Telefonnummer oder E-Mail-Adresse hat, kann angeschrieben werden.",
        noRespondersFound: "Ihre Gästeliste ist leer – es gibt niemanden zum Importieren.",
        noReachableResponders: "Niemand auf Ihrer Gästeliste hat eine Telefonnummer oder E-Mail-Adresse, daher gibt es hier niemanden zum Anschreiben.",
        respondersFailed: "Ihre Gästeliste konnte nicht geladen werden: ",
        respondersUnreachableNote: "{count} weitere auf Ihrer Gästeliste haben weder Telefonnummer noch E-Mail und können nicht angeschrieben werden.",
        respondersAlreadyAdded: "Bereits in Ihrer Liste",
        rsvpStatusColumn: "Antwort",
        rsvpFilterAll: "Alle",
        rsvpFilterYes: "Nimmt teil",
        rsvpFilterMaybe: "Vielleicht",
        rsvpFilterNo: "Nimmt nicht teil",
        rsvpFilterWaitlisted: "Warteliste",
        rsvpFilterPending: "Antwort ausstehend",
        rsvpStatusYes: "Ja",
        rsvpStatusMaybe: "Vielleicht",
        rsvpStatusNo: "Nein",
        rsvpStatusWaitlisted: "Warteliste",
        rsvpStatusPending: "Antwort ausstehend",
        addMoreContacts: "Weitere Kontakte hinzufügen",
        exportCsv: "CSV exportieren",
        status: "Status",
        tags: "Tags",
        allTags: "Alle Tags",
        replaceFile: "Datei ersetzen",
        maxGuestsCol: "Max. Gäste",
        maxGuestsColHint: "Maximale Anzahl Gäste, die diese Einladung mitbringen darf (leer lassen, um das Standardlimit des Formulars zu verwenden)",
        // The guest-list columns (task #935)
        guestNamesCol: "Gastname(n)",
        guestNamesColHint: "So tragen Sie Gastnamen ein\n• Trennen Sie Namen mit einem Semikolon (;). Kommas gehen auch.\n• Schreiben Sie (Kind) hinter den Namen eines Kindes, z. B. Leon Schmidt (Kind).\n• Beispiel: Anna Schmidt; Max Schmidt; Leon Schmidt (Kind)\n• Telefon und E-Mail der Zeile gehören zur ersten genannten Person.",
        guestNamesPh: "Sarah Schmidt; Michael Schmidt",
        groupNameCol: "Gruppenname",
        groupNameColHint: "An wen die Einladung gerichtet ist, z. B. Familie Schmidt. Er steht auf dem Umschlag und in der Begrüßung des Formulars; Nachrichten sprechen die Gastnamen an („Hallo Anna & Max“).\nFür einen Gast, der allein eingeladen ist, leer lassen. Steht nur der Gruppenname da, finden die Gäste ihre Einladung darüber und geben ihre Namen ein; mit Gastnamen findet jeder sie über seinen eigenen Namen.",
        groupNamePh: "Familie Schmidt",
        contactPreviewTitle: "So erscheint diese Einladung",
        contactPreviewEnvelope: "Adressiert an",
        contactPreviewGreetingLine: "Hallo {name}",
        contactPreviewLookup: "Wer einen dieser Namen eingibt, findet diese Einladung:",
        contactPreviewNoLookup: "Fügen Sie einen Nachnamen oder Gruppennamen hinzu, damit dieser Gast die Einladung über seinen Namen findet.",
        contactPreviewAsksNames: "Noch keine Namen: Wer sie findet, wird nach den Namen seiner Gruppe gefragt.",
        diffSurnamesTip: "Tipp: Fügen Sie für jedes Gruppenmitglied eine Telefonnummer, E-Mail-Adresse oder den vollständigen Namen hinzu, damit jede Person ihre Antwort leicht findet.",
        sameNameWarning: "Achtung: Mehrere Gäste oder Gruppen haben denselben Namen. Fügen Sie für jeden eine E-Mail-Adresse oder Telefonnummer hinzu, damit sie sich bei der Suche ausweisen können.",
        lastFirstFlag: "Eine Person, Nachname zuerst? Trennen Sie verschiedene Personen mit „;“.",
        prefillNameLabel: "Den Namen jedes Gastes im Formular vorausfüllen",
        prefillNameDesc: "Jeder persönliche Link öffnet sich mit dem Namen des Kontakts bereits im Namensfeld (und auf dem Umschlag, wenn dieser Schalter an ist). Ausschalten, wenn die Liste Spitznamen oder geteilte Nummern enthält – die Gäste tippen ihren Namen selbst; die Gästelimits gelten weiterhin.",
        contactsSelected: "Kontakt(e) ausgewählt",
        addSelected: "Auswahl hinzufügen",
        selectAll: "Alle auswählen",
        importedContactsSummary: "{added} Kontakt(e) importiert. {skipped} als Duplikate übersprungen.",
        noOrgFound: "Keine Organisation gefunden. Richten Sie Ihre Organisation zuerst ein.",
        noOrgContacts: "Keine Kontakte in Ihrer Organisation gefunden. Fügen Sie zuerst Kontakte hinzu.",
        failedToLoadContacts: "Kontakte konnten nicht geladen werden: ",
        selectAtLeastOneContact: "Bitte wählen Sie mindestens einen Kontakt aus.",
        contactsClearedMessage: "Kontakte gelöscht. Sie können jetzt eine neue Liste hochladen.",
        unsavedContactsWarning: "Sie haben ungespeicherte Kontakte. Drücken Sie Abbrechen zum Zurückkehren und Speichern, oder OK zum Verwerfen.",
        unsupportedFileType: "Nicht unterstützter Dateityp. Bitte laden Sie eine CSV (.csv) oder vCard (.vcf) Datei hoch.",
        fileAlreadyUploaded: "Die Datei \"{filename}\" wurde bereits hochgeladen.",
        fileReplaced: "Die {replaced} Kontakte aus \"{filename}\" wurden durch die {count} aus der gerade hochgeladenen Datei ersetzt.",
        fileMergedSummary: "{added} Kontakt(e) aus \"{filename}\" hinzugefügt; {updated} bereits in Ihrer Liste mit den Angaben der Datei aktualisiert.",
        failedToProcessFile: "Datei konnte nicht verarbeitet werden. Bitte Format prüfen und erneut versuchen.",
        noContactsInFile: "Wir haben „{filename}\" gelesen, darin aber keine Kontakte gefunden.\n\nGefundene Spalten: {headers}\n\nJeder Kontakt braucht eine E-Mail-Adresse oder eine Telefonnummer unter einer Überschrift, die wir erkennen — zum Beispiel „name\", „email\", „phone\". Benennen Sie die Überschriften in Ihrer Tabelle um und laden Sie die Datei erneut hoch.",
        encodingDamageWarning: "\"{filename}\" scheint seine nicht-englischen Zeichen verloren zu haben – Namen erscheinen als \"???\" oder als unlesbarer Text.\n\nDas passiert meist, wenn Excel auf einem Mac eine normale .csv-Datei speichert. Der ursprüngliche Text ist bereits nicht mehr in der Datei, ein Import würde also Kontakte mit unlesbaren Namen anlegen.\n\nSo beheben Sie das: Wählen Sie in Excel Datei → Speichern unter → \"CSV UTF-8 (durch Trennzeichen getrennt)\" und laden Sie die Datei erneut hoch. Google Sheets und Numbers exportieren automatisch korrekte Dateien.\n\nTrotzdem importieren?",
        processingFile: "{filename} wird verarbeitet...",
        missingNamesWarning: "{count} Kontakt(e) haben keinen Namen — sie erscheinen als „Unbekannt\". Ergänze sie unten in der Liste.",
        // Household invitations (task #908)
        householdCouplesSuggest: "{count} Einladung(en) nennen mehr als eine Person, z. B. „{example}“. Alle Genannten mitzählen und ihre Namen im Formular vorausfüllen?",
        householdCouplesYes: "Ja, mitzählen",
        householdNoThanks: "Nein, danke",
        householdFamiliesNote: "{count} Einladung(en) gehen an eine Familie, z. B. „{example}“. Tragen Sie unter {members} ein, wer kommt (oder legen Sie {maxGuests} fest), damit das Formular die Namen ausfüllt und richtig zählt.",
        loadingText: "Laden...",
        verifyingPayment: "Zahlungsstatus wird überprüft...",
        pleaseWaitVerify: "Bitte warten Sie, während wir Ihr Upgrade bestätigen",
        paymentVerified: "Zahlung bestätigt!",
        paymentProcessing: "Zahlung wird verarbeitet",
        errorVerifyingPayment: "Fehler bei der Zahlungsüberprüfung",
        validLabel: "Gültig",
        checkLabel: "Prüfen",
        toCheck: "zu prüfen",
        phoneCheckChargedNote: "wird so gesendet und berechnet, wenn Sie es nicht korrigieren",
        phoneWarnDoubledCc: "die Ländervorwahl steht doppelt",
        phoneWarnCc927: "927 ist keine Ländervorwahl — meinten Sie +972?",
        phoneWarnNanpArea: "bei einer +1-Nummer darf die Vorwahl nicht mit 0 oder 1 beginnen",
        phoneWarnNanpNoCc: "wenn das eine US- oder kanadische Nummer ist, braucht sie +1: {suggest}",
        phoneWarnLength: "eine +{cc}-Mobilnummer hat {want} Ziffern nach der Ländervorwahl, diese hat {got}",
        phoneWarnUkPrefix: "eine +44-Mobilnummer beginnt mit 7",
        phoneWarnIlPrefix: "eine +972-Mobilnummer beginnt mit 5",
        phoneWarnAssumed: "ohne Ländervorwahl — gelesen als {country} ({number}); ändern Sie es, falls das falsch ist",
        phoneWarnNeedsCountry: "ohne Ländervorwahl — bitte am Anfang ergänzen, z. B. +49",
        phoneWarnInvalid: "keine gültige Nummer ({country}) — bitte die Ziffern prüfen",
        phoneWarnInvalidAny: "keine gültige Telefonnummer — bitte die Ziffern prüfen",
        phoneWarnLandline: "eine Festnetznummer ({country}) — sie kann weder WhatsApp noch SMS empfangen",
        phoneCountryLabel: "Nummern ohne Ländervorwahl werden gelesen als",
        phoneCountryHint: "Die meisten Nummern in Ihrer Liste sind aus: {country}.",
        phoneCountryUse: "{country} verwenden",
        contactsLoaded: "Kontakte geladen",
        countryUnknown: "Unbekannt",
        rowLabel: "Zeile",
        deliveryDisclaimer: "Eine Zustellung ist nie zu 100 % garantiert. Ein kleiner Teil der Nachrichten kann durch die Marketing-Limits von Meta, Filter der Mobilfunkanbieter, Spam-Ordner oder ungültige Kontaktdaten zurückgehalten werden – das ist bei jeder Messaging-Plattform normal.",
        tagsCol: "Tags",
        tagsColHint: "Zu welcher Gruppe dieser Gast gehört, z. B. Familie, nur Empfang. Tags mit Kommas trennen.\nWenn ein Teil der Veranstaltung auf bestimmte Tags beschränkt ist (im Editor unter Teile der Veranstaltung), zeigt der persönliche Link dieses Gastes nur die Teile, zu denen seine Tags passen.",
        campaignNameDupAddInstead: "Hier klicken, um die Kontakte stattdessen direkt zu Ihrer bestehenden Nachricht",
        campaignNameDupAddInsteadSuffix: "hinzuzufügen",
        progressChecklistTitle: "Ihr Fortschritt",
        checkCampaignName: "Name der Nachricht",
        checkAddContacts: "Kontakte hinzufügen",
        checkCustomizeMessage: "Nachricht anpassen",
        checkConfigureFollowUp: "Nachfassen einrichten",
        checkSendInvitations: "Einladungen senden",
        contactsSummaryTitle: "Kontaktübersicht",
        totalGuestsAdded: "Hinzugefügte Gäste insgesamt",
        contactsImported: "Importierte Kontakte",
        needsAttention: "Bitte prüfen",
        supportedImportMethods: "Importmöglichkeiten",
        manualEntry: "Manuelle Eingabe",
        headerOptional: "(Optional)",
        renameTooltip: "Umbenennen",
        gateNoRecipients: "Bitte fügen Sie mindestens einen Empfänger hinzu, bevor Sie zum Senden gehen.",
        gateNoMessage: "Bitte schreiben Sie Ihre Nachricht, bevor Sie zum Senden gehen.",
        gateGoToStep: "Zu Schritt {n}",
        sendStalled: "Die Verbindung zu unseren Servern ist abgebrochen, bevor Ihre Nachricht gespeichert wurde – es wurde nichts gesendet und keine Credits verbraucht. Laden Sie die Seite neu, öffnen Sie die Nachricht erneut und tippen Sie noch einmal auf Senden.",
        loadingSites: "Ihre Hochzeitswebsites werden geladen…",
        noWeddingSites: "Keine Hochzeitswebsite gefunden.",
        createWeddingSite: "Eine erstellen",
        usingSite: "Verwendet:",
        chooseSite: "Hochzeitswebsite wählen…",
        siteNotPublished: "zum Verwenden veröffentlichen",
        noPublishedSite: "Noch keine Ihrer Hochzeitswebsites ist veröffentlicht – veröffentlichen Sie eine, damit Gäste antworten können.",
        rsvpEnabledHint: "Achten Sie darauf, dass die RSVP-Seite Ihrer Website eingeschaltet ist, damit Gäste antworten können.",
        loadingFollowUp: "Nachfass-Nachricht wird geladen...",
        loadingDraft: "Entwurf wird geladen...",
        creditsAlreadyEnough: "Sie haben bereits genug Credits für diese Nachricht – prüfen Sie sie und tippen Sie auf Senden.",
        remindersSkippedBeforeSend: "{count} Erinnerung(en) nicht geplant – ihr Zeitpunkt liegt vor dem Versand dieser Nachricht.",
        invalidLabel: "Ungültig",
        verifyCountryCode: "⚠ Ländervorwahl überprüfen",
        enterGuestName: "Gastname eingeben",
        emailPlaceholder: "name@beispiel.de",
        phonePlaceholder: "+491234567890",
        validContacts: "Gültige Kontakte",
        scheduledTimePast: "Der geplante Zeitpunkt kann nicht in der Vergangenheit liegen",
        recipientsLabel: "Empfänger",
        noNameLabel: "(kein Name)",
        removeRecipient: "Entfernen",
        removeThisContact: "Diesen Kontakt entfernen",
        allRecipientsRemoved: "Alle Empfänger wurden entfernt. Fügen Sie wieder welche hinzu, um zu senden.",
        sendNoFormSelected: "Für diese Nachricht ist kein Formular ausgewählt. Öffnen Sie zuerst ein gespeichertes Formular und senden Sie dann erneut.",
        sendFormNotSaved: "Ihr Formular ist noch nicht fertig gespeichert. Öffnen Sie es erneut im Editor, speichern Sie es und senden Sie dann erneut.",
        draftSavedFindOnDashboard: "Entwurf gespeichert. Sie finden ihn in Ihrem Dashboard unter Nachrichten.",
        processingButton: "Verarbeitung...",
        personalize: "Personalisieren:",
        demoLabel: "Demo",
        searchContactsPlaceholder: "Nach Name, E-Mail oder Telefon suchen...",
        loading: "Laden...",

        // New wizard keys
        fullNamePlus: "+ Vollständiger Name",
        firstNamePlus: "+ Vorname",
        emailPlus: "+ E-Mail",
        tableNumberPlus: "+ Tischnummer",
        tableTagDisabledHint: "Richte den integrierten Sitzplan ein, um mit der Tischnummer jedes Gastes zu personalisieren.",
        tableExampleInput: "Dein Tisch ist {{table_number}}",
        tableSplitNoticeOne: "1 Gruppe sitzt an mehr als einem Tisch, ohne dass jeder Gast einen Namen hat. Ihre Tischzeile sieht dann so aus: „Dana 2, Dana 3“. Trage den Namen jedes Gastes in der Gästeliste ein, damit es klar ist.",
        tableSplitNoticeMany: "{count} Gruppen sitzen an mehr als einem Tisch, ohne dass jeder Gast einen Namen hat. Ihre Tischzeile sieht dann so aus: „Dana 2, Dana 3“. Trage den Namen jedes Gastes in der Gästeliste ein, damit es klar ist.",
        clickToInsert: "Klicken zum Einfügen — jeder Gast erhält seine personalisierte Version.",
        seeExample: "Beispiel anzeigen",
        hideExample: "Beispiel ausblenden",
        youWrite: "Sie schreiben:",
        exampleInput: "Hallo {{first_name}}, du bist zu unserem Event eingeladen!",
        eachGuestGets: "Jeder Gast erhält:",
        sendTestEmailToMe: "Mir zuerst eine Test-E-Mail senden",
        testEmailSending: "Test-E-Mail wird gesendet…",
        testEmailSent: "Test-E-Mail gesendet an {email}",
        testEmailFailed: "Test-E-Mail konnte nicht gesendet werden",
        sendTestTitle: "Test an sich selbst senden",
        sendTestSubtitle: "Erhalten Sie eine echte Kopie auf Ihr Handy und in Ihr Postfach – genau so, wie Ihre Gäste sie sehen.",
        sendTestBtn: "Test senden",
        sendTestCostNote: "Der erste Test dieser Nachricht ist kostenlos. Danach kostet jeder Test per SMS oder WhatsApp 1 Guthaben – E-Mail-Tests sind immer kostenlos.",
        sendTestCostAfterFree: "Ihr kostenloser Test für diese Nachricht ist aufgebraucht. Jeder weitere Test per SMS oder WhatsApp kostet 1 Guthaben – E-Mail-Tests bleiben kostenlos.",
        sendTestPhoneLabel: "Mobilnummer für den Test",
        sendTestPhoneHint: "Ihr Konto hat keine Mobilnummer. Geben Sie eine an, an die der Test gehen soll. Wir merken sie uns.",
        sendTestPhoneInvalid: "Das sieht nicht nach einer Mobilnummer aus. Bitte im internationalen Format, zum Beispiel +14155550123.",
        sendTestSending: "Ihr Test wird gesendet…",
        sendTestDone: "Test an Sie gesendet",
        sendTestEmailCopyOnly: "Die E-Mail ist nur eine Kopie für Sie — Ihre Gäste erhalten keine E-Mail.",
        sendTestFailed: "Test konnte nicht gesendet werden",
        sendTestCreditReturned: "Das Guthaben für diesen Test wurde Ihnen wieder gutgeschrieben.",
        sendTestEmptyMessage: "Schreiben Sie zuerst Ihre Nachricht — es gibt noch nichts zu testen.",
        sendTestRoutedToWhatsApp: "Nummer außerhalb der USA — dieser Test läuft daher über WhatsApp.",
        // A test parked waiting for Meta, and every way that wait can end (task #604).
        sendTestQueued: "Ihr Test steht in der Warteschlange. WhatsApp prüft Ihre Nachricht noch — der Test geht von selbst raus, sobald sie genehmigt ist. Hier ist nichts weiter zu tun.",
        sendTestQueuedSent: "Genehmigt — Ihr Test wurde gerade an Ihr WhatsApp gesendet.",
        sendTestQueuedFailed: "WhatsApp hat Ihre Nachricht genehmigt, aber der Test konnte nicht gesendet werden. Tippen Sie auf Test senden, um es erneut zu versuchen.",
        sendTestQueuedNoCredits: "WhatsApp hat Ihre Nachricht genehmigt, aber der wartende Test brauchte ein Guthaben und es war keines verfügbar. Laden Sie auf und tippen Sie erneut auf Test senden.",
        sendTestQueuedExpired: "Ihr wartender Test ist abgelaufen, bevor WhatsApp die Nachricht genehmigt hat. Tippen Sie erneut auf Test senden, um jetzt einen zu senden.",
        // What the status webhook later says about an accepted WhatsApp test.
        sendTestDelivered: "In Ihrem WhatsApp zugestellt ✓",
        sendTestNotDelivered: "Der WhatsApp-Test wurde nicht zugestellt",
        sendTestMetaLimit: "WhatsApp hat diesen Test nicht zugestellt: Meta begrenzt, wie viele Marketing-Nachrichten eine Telefonnummer empfangen kann, und wiederholte Tests können dieses Limit bei Ihrer eigenen Nummer erreichen. Ihre Kampagne und Ihre Gäste sind davon NICHT betroffen — Sie können bedenkenlos senden. Um sofort erneut zu testen, schicken Sie eine beliebige Nachricht (auch nur „Hallo“) an die WhatsApp-Nummer, von der Ihr letzter Test kam, und versuchen Sie es dann noch einmal — in einem offenen Chat gilt das Limit nicht. Andernfalls warten Sie ein paar Stunden.",
        includeRsvpLink: "RSVP-Link in die Nachricht aufnehmen",
        rsvpLinkDisabledDesc: "Wenn deaktiviert, wird die Nachricht ohne Link zum RSVP-Formular gesendet.",
        includeQrCode: "QR-Code für Check-in aufnehmen",
        qrCodeDesc: "Gäste mit Zusage erhalten ihren persönlichen Check-in QR-Code.",
        qrCodeWhatsappNote: "Bei WhatsApp ersetzt der QR-Code das Nachrichtenbild.",
        finalCampaignSummary: "Abschließende Nachrichtenübersicht",
        messagesToSend: "Zu sendende Nachrichten",
        creditsUsed: "Verwendete Credits",
        clickingScheduleNote: "Durch Klicken auf \"Planen & Senden\" werden Ihre Nachrichten in die Warteschlange gestellt.",
        scheduleAndSend: "Planen & Senden",
        canStillGoBack: "Sie können noch zurückgehen und Änderungen vornehmen.",
        campaignSentSuccessfully: "Nachricht erfolgreich gesendet!",
        messagesBeingDelivered: "Ihre {count} Nachrichten werden jetzt zugestellt.",
        windowWillClose: "Dieses Fenster wird automatisch geschlossen...",
        closeButton: "Schließen",
        smsConsentAgree: "Ich stimme den",
        andText: "und",
        buyMessageCredits: "Nachrichten-Credits kaufen",
        campaignRequires: "Nachricht benötigt:",
        yourBalanceLabel: "Ihr Guthaben:",
        needLabel: "Benötigt:",
        selectPackage: "Paket auswählen:",
        bestValue: "Bester Wert",
        calcHelper: "Wie viele Guthaben brauche ich?",
        freeShareBalance: "Sie haben {n} Nachrichten-Guthaben (jedes Konto startet mit 25 gratis), und Ihre erste Testnachricht ist ebenfalls kostenlos.",
        freeShareLead: "Lieber selbst per Handy oder E-Mail senden? Ohne Guthaben:",
        freeShareCopy: "Link kopieren",
        freeSharePersonal: "Persönliche Links",
        freeShareCopied: "Link kopiert",
        calcGuests: "Gäste",
        calcMsgs: "Nachrichten je Gast",
        calcCadence: "Die meisten Gastgeber senden 3 Nachrichten pro Gast: Einladung, Erinnerung, Tageserinnerung. Erinnerungen gehen meist nur an Personen ohne Antwort — der echte Verbrauch ist oft niedriger.",
        creditsAmount: "{count} Credits",
        creditsMoreAmount: "{count} weitere Credits",
        creditsUnit: "Credits",
        packEnoughForSend: "Reicht für diese Nachricht",
        packNeedMore: "Es fehlen {count}",
        creditsNeverExpireNote: "Credits verfallen nie • Für alle Formulare nutzbar",
        haveEnoughCredits: "Sie haben genug Credits!",
        creditsAvailableNeeded: "{balance} Credits verfügbar ({needed} benötigt)",
        selectCreditPackage: "Bitte wählen Sie ein Credit-Paket",
        purchaseStartFailed: "Der Kauf konnte nicht gestartet werden. Bitte versuchen Sie es erneut.",
        previewNotInteractive: "Vorschau — nicht interaktiv",
        emailTab: "E-Mail",
        whatsappTab: "WhatsApp",
        smsTab: "SMS",
        translating: "Übersetze...",
        otherLanguage: "Andere Sprache",
        campaignSubmittedSuccessfully: "Nachricht erfolgreich gesendet!",
        submittingCampaign: "Nachricht wird gesendet...",
        submissionFailed: "Senden fehlgeschlagen",
        submitting: "Sende...",
        errorDetails: "Fehlerdetails:",
        missingEmailAndPhone: "E-Mail und Telefon fehlen",
        invalidEmailFormat: "Ungültiges E-Mail-Format",
        invalidPhoneFormat: "Ungültiges Telefon-Format",
        paymentSuccessful: "Zahlung erfolgreich!",
        unknownError: "Unbekannter Fehler",
        removeImage: "Bild entfernen",
        pendingTranslation: "Übersetzung ausstehend",
        removeLanguage: "Sprache entfernen",
        notSpecified: "Nicht angegeben",
    }
};

// Register with dashboard language system if available
if (window.DashboardLanguageSystem) {
    window.DashboardLanguageSystem.registerLanguageContent('de', window.GermanDashboardContent);
}
